import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren, Suspense } from 'react';
import { useElementTopPosition } from '@/hooks/useElementTopPosition';
import { mergeClasses } from '@/utils/style';
import { Link, type LinkProps } from '@/components/links';
import ChevronLeftIcon from '@/assets/icons/heroIcons/Chevron-left.svg';
import dynamic from 'next/dynamic';
const PointingMascots = dynamic(() => import('@/components/animation/PointingMascots').then(mod => mod.PointingMascots), {
  ssr: false
});
interface Props {
  title?: string;
  backLink?: LinkProps;
  className?: string;
  titleClassName?: string;
  circleClassName?: string;
  contentClassName?: string;
  withoutCharacters?: boolean;
}
function HeroSimple(t0) {
  const $ = _c(33);
  const {
    title,
    backLink,
    className,
    titleClassName,
    circleClassName,
    children,
    contentClassName,
    withoutCharacters
  } = t0;
  const [ref, t1] = useElementTopPosition();
  const {
    absoluteTop
  } = t1;
  let t2;
  if ($[0] !== className) {
    t2 = mergeClasses("relative", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== circleClassName) {
    t3 = mergeClasses("bgCircle absolute top-0 left-0 h-[30rem] w-[30rem] -translate-x-1/2 -translate-y-1/2 rotate-180 lg:h-[50rem] lg:w-[50rem] lg:-translate-x-1/3 lg:-translate-y-1/3", circleClassName);
    $[2] = circleClassName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== contentClassName) {
    t5 = mergeClasses("z-10 pt-[8rem] pb-10 lg:pt-[16rem] lg:pb-20", contentClassName);
    $[6] = contentClassName;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = backLink && "flex-row";
  let t7;
  if ($[8] !== t6) {
    t7 = mergeClasses("mx-auto flex max-w-292 flex-col items-center text-center", t6);
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== backLink) {
    t8 = backLink && <Link {...backLink} className="z-10"><ChevronLeftIcon className="h-6 w-6 text-gray-900 md:h-12 md:w-12" /></Link>;
    $[10] = backLink;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== backLink || $[13] !== title || $[14] !== titleClassName) {
    t9 = title && <h1 className={mergeClasses("4xl:text-8xl mx-auto text-center text-4xl font-bold lg:text-7xl", backLink && "pr-6 md:pr-12", titleClassName)}>{title}</h1>;
    $[12] = backLink;
    $[13] = title;
    $[14] = titleClassName;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== children || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className="relative z-10 px-4"><div className={t7}>{t8}{t9}{children}</div></div>;
    $[16] = children;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== absoluteTop || $[22] !== ref || $[23] !== withoutCharacters) {
    t11 = !withoutCharacters && <div className="relative my-10 flex justify-between lg:absolute lg:top-[12rem] lg:right-0 lg:left-0 lg:my-0" ref={ref}><Suspense><PointingMascots displayImagePriority={true} heartClassName="relative -top-8 max-w-[50%] lg:top-0" brainClassName="relative max-w-[50%]" absoluteTop={absoluteTop} /></Suspense></div>;
    $[21] = absoluteTop;
    $[22] = ref;
    $[23] = withoutCharacters;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t5) {
    t12 = <div className={t5}>{t10}{t11}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t5;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t2 || $[31] !== t4) {
    t13 = <div className={t2}>{t4}{t12}</div>;
    $[29] = t12;
    $[30] = t2;
    $[31] = t4;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
}
export default HeroSimple;